import React from 'react';

const StreamlinedUnmuteModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 p-4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 text-center w-full max-w-sm max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-extrabold mb-2">Turn Sounds On?</h2>
        <p className="text-gray-600 mb-6">A grown-up needs to enter the code to turn sounds back on for the app.</p>
        <button
          onClick={onConfirm}
          className="w-full bg-green-500 text-white font-bold py-3 rounded-xl mb-3 transition active:scale-95"
        >
          Turn On Sounds
        </button>
        <button
          onClick={onClose}
          className="w-full text-gray-600 font-bold py-2"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default StreamlinedUnmuteModal;
